import type { ShapeData } from '@/lib/shapes/types/shape-data'
import {
  isShapeFrozenForGeometry,
  isShapeLockedForUserEdit,
} from '@/lib/groups/element-edit-policy'

/** CSS custom property values: selection border color at 10% alpha (see `index.css`). */
export const GROUP_HOVER_FILL_NORMAL = 'var(--editor-group-hover-fill-normal)'
export const GROUP_HOVER_FILL_FROZEN = 'var(--editor-group-hover-fill-frozen)'
export const GROUP_HOVER_FILL_LOCKED = 'var(--editor-group-hover-fill-locked)'

export type GroupHoverFillTone = 'normal' | 'frozen' | 'locked'

/** Class applied to kind-7 group paths; fill on `:hover` uses `--shape-group-hover-fill`. */
export const SHAPE_GROUP_HOVER_FILL_CLASS = 'shape-group-hover-fill'

/** Hover fill tone for a group (lock wins over freeze, same as selection chrome). */
export function groupHoverFillToneForShape(
  shape: ShapeData,
  shapesById: Map<string, ShapeData>
): GroupHoverFillTone {
  if (isShapeLockedForUserEdit(shape, shapesById)) return 'locked'
  if (isShapeFrozenForGeometry(shape, shapesById)) return 'frozen'
  return 'normal'
}

export function groupHoverFillCssVarForTone(tone: GroupHoverFillTone): string {
  switch (tone) {
    case 'locked':
      return GROUP_HOVER_FILL_LOCKED
    case 'frozen':
      return GROUP_HOVER_FILL_FROZEN
    default:
      return GROUP_HOVER_FILL_NORMAL
  }
}

export type GroupHoverStyle = {
  fill: string
}

export function groupHoverStyleForShape(
  shape: ShapeData,
  shapesById: Map<string, ShapeData>
): GroupHoverStyle {
  const tone = groupHoverFillToneForShape(shape, shapesById)

  return {
    fill: groupHoverFillCssVarForTone(tone),
  }
}

/** Resolves the `--shape-group-hover-fill` value for a kind-7 group path. */
export function groupHoverFillForShape(
  shape: ShapeData,
  shapesById: Map<string, ShapeData>
): string {
  return groupHoverStyleForShape(shape, shapesById).fill
}
